<template>
    <div>
        <div class="muven-card">
            <div class="muven-card-title">
                <p>
                    Status dos pedidos em aberto

                    <router-link 
                        class="btn btn-outline-secondary btn-sm float-right"
                        :to="orderListWithFilter">
                        <fa icon="external-link-alt" />
                    </router-link>
                </p>
            </div>

            <div>
                <highcharts :options="pendingOrdersStatusChartOptions" ref="chart"/>
            </div>
        </div>
    </div>
</template>

<script>
import Highcharts from 'highcharts'
import router from '@/router'
import dashboardService from '@/dashboard/services/DashboardService'
import {createGraphic} from '@/utils/normalizers/GraphicNormalizer'
import {dateTimeFilter} from '@/utils/filters/DateTimeFilter'
import {simpleCurrencyFilter} from '@/utils/filters/SimpleCurrencyFilter'
import {differenceInDays} from '@/utils/helpers/DateHelper'
import {sum} from 'lodash'
import { OrderStatusEnum } from '@c2b/muven-commons'

export default {
    name: 'PendingOrdersStatusCmp',
    data() {
        return {
            orderListWithFilter: `/pedidos?custom=true`,
            pendingList: [],
            pendingOrdersStatusChartOptions: createGraphic({
                chart: {
                    type: 'pie',
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    height: 300
                },
                tooltip: {
                    formatter() {
                        return `
                            ${this.point.pendingOrder.description}: <b>${this.point.pendingOrder.total}</b>
                        `   
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                            point: {
                                events: {
                                    click() {
                                        router.push(`/pedidos/?custom=true&statusList=${this.orderStatusEnum}`)
                                    }   
                                }
                            },
                    },
                },
                legend: {
                    enabled: true,
                },
                series: [
                    {
                        data: [],
                    }
                ]
            }),
        }
    },
    async mounted() {
        this.pendingList = await dashboardService.getPendingOrdersStatus()

        if (this.pendingList.length) {
            this.orderListWithFilter += `&statusList=${this.pendingList.map((p) => p.idStatus).join(',')}`
        }

        this.$refs.chart.chart.series[0].setData(this.pendingList.map((p, index) => {
            return {
                orderStatusEnum: p.idStatus,
                y: p.total,
                name: `${p.description} (${p.total})`,
                pendingOrder: {
                    ...p,
                },
            }
        }))
    },
}
</script>
